import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchRtp, type FetchRtpParams } from '../../api/fetchers/rtp/fetcher';

interface FetchRtpActionParams extends FetchRtpParams {
  essential?: boolean;
}

export const fetchRtpAction = createAsyncThunk('rtp/fetchRtp', (params: FetchRtpActionParams) => fetchRtp(params));
